import { InputTitle } from 'components/input/InputTitle';
import { ConfirmModal } from 'components/modal/ConfirmModal';
import {
  FileUpload,
  Radio,
  Spacing,
  TextInput,
  Textarea,
  Typography,
  closeModal,
  openModal,
} from 'enable-ui';

import { RoleKey } from 'modules/auth/core/enum';
import { MODAL_KEY } from 'modules/auth/core/modal-key';

import { CustomFileUpload, CustomInput, CustomRadio } from '../styles/dashboard';

import { ReactComponent as UploadIcon } from 'assets/icons/upload.svg';

import { checkRole } from 'helpers';

import { useExercisesFormController } from '../core/controller/exercises-form';
import { ExerciseContentCategory } from '../core/enum';
import { Footer } from './Footer';
import { HeaderDetailPage } from './HeaderDetailPage';
import { Video } from './Video';

export const BodyFormExercise = () => {
  const {
    values,
    errors,
    disabled,
    handleChange,
    handleSubmit,
    onChangeCategory,
    categories,
    onCancel,
    exerciseId,
    handleDeleteExercise,
    disabledButton,
    hideDeletecAction,
    exerciseDetail,
    goBack,
    onChangeVideo,
    onChangeThumbnail,
    videoUrl,
    thumbnailUrl,
    handleRemoveVideo,
    handleRemoveThumbnail,
    handleGetWidthAndHeightThumbnail,
    handleGetWidthAndHeightVideo,
    levels,
    onChangeLevel,
    handleChangeUpperBody,
    handleChangeLowerBody,
    handleKeyDownLowerAndUpperBody,
    categoryKey,
  } = useExercisesFormController();

  const disabledField = checkRole([RoleKey.TRAINER_INSTITUTION, RoleKey.TRAINER_BIOLOGIC]);

  const handleKeyPress = (e: any) => {
    const keyCode = e.keyCode || e.which;
    const keyValue = String.fromCharCode(keyCode);

    if ((e.target.value === '' && keyValue === '0') || keyValue === '-') {
      e.preventDefault();
      e.preventDefault();
    }
  };

  const isWarmupOrCooldownOrCheerup =
    categoryKey === ExerciseContentCategory.WARMUP ||
    categoryKey === ExerciseContentCategory.COOLDOWN ||
    categoryKey === ExerciseContentCategory.MIDPOINTCHEERUP ||
    categoryKey === ExerciseContentCategory.ENDINGCHEERUP;

  return (
    <div style={{ width: '800px' }}>
      <HeaderDetailPage
        title={exerciseId ? String(exerciseDetail?.name) : 'Add Excersise'}
        showAction={Boolean(exerciseId) && !hideDeletecAction}
        actions={[
          {
            label: 'Delete',
            onClick: () => openModal(MODAL_KEY.DELETE_EXERCISE),
          },
        ]}
        goBack={goBack}
      />

      <Spacing spacing="xl" placement="bottom" type="margin">
        <InputTitle title="Exercise name" />
        <TextInput
          name="name"
          containerStyle={{ maxWidth: 'auto' }}
          inputStyle={{
            backgroundColor: 'transparent',
          }}
          value={values.name}
          onChange={handleChange}
          maxLength={80}
          helperText={errors.name}
          disabled={disabledField}
        />
      </Spacing>

      <Spacing spacing="xl" placement="bottom" type="margin">
        <InputTitle title="Category" />
        <div style={{ display: 'flex', alignItems: 'center', gap: 12, flexWrap: 'wrap' }}>
          {categories.map((category, index) => {
            const checked = category?.id === values.category;

            return (
              <CustomRadio>
                <Radio
                  key={index}
                  checked={checked}
                  onClick={disabledField ? undefined : onChangeCategory(category)}
                  disabled={disabledField}
                  color={checked ? '#fd8a24' : 'rgba(0, 0, 0, 0.25)'}
                >
                  <Typography
                    style={{
                      textAlign: 'start',
                      width: 'calc(100% - 24px)',
                      fontSize: '18px',
                      lineHeight: '26px',
                      color: '#222222',
                      whiteSpace: 'nowrap',
                    }}
                  >
                    {category.name}
                  </Typography>
                </Radio>
              </CustomRadio>
            );
          })}
        </div>
      </Spacing>

      {!isWarmupOrCooldownOrCheerup && (
        <>
          <Spacing spacing="xl" placement="bottom" type="margin">
            <InputTitle title="Level" />
            <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
              {levels.map((level, index) => {
                const checked = level === values.level;

                return (
                  <CustomRadio>
                    <Radio
                      key={index}
                      checked={checked}
                      onClick={onChangeLevel(level)}
                      disabled={disabledField}
                      color={checked ? '#fd8a24' : 'rgba(0, 0, 0, 0.25)'}
                    >
                      <Typography
                        style={{
                          textAlign: 'start',
                          width: 'calc(100% - 24px)',
                          fontSize: '18px',
                          lineHeight: '26px',
                          color: '#222222',
                        }}
                      >
                        {level}
                      </Typography>
                    </Radio>
                  </CustomRadio>
                );
              })}
            </div>
          </Spacing>

          <Spacing
            spacing="xl"
            placement="bottom"
            type="margin"
            style={{ display: 'flex', alignItems: 'center', gap: 12 }}
          >
            <div style={{ width: '50%' }}>
              <InputTitle title="Upper Body (%)" />
              <TextInput
                name="upperBody"
                containerStyle={{ maxWidth: 'auto' }}
                inputStyle={{
                  backgroundColor: 'transparent',
                }}
                type="number"
                value={values.upperBody}
                onChange={handleChangeUpperBody}
                onKeyDown={handleKeyDownLowerAndUpperBody}
                min={1}
                // onKeyUp={handleLimitUpperBody}
              />
            </div>

            <div style={{ width: '50%' }}>
              <InputTitle title="Lower Body (%)" />
              <TextInput
                name="lowerBody"
                containerStyle={{ maxWidth: 'auto' }}
                inputStyle={{
                  backgroundColor: 'transparent',
                }}
                type="number"
                value={values.lowerBody}
                onChange={handleChangeLowerBody}
                onKeyDown={handleKeyDownLowerAndUpperBody}
                min={1}
                // onKeyUp={handleLimitLowerBody}
              />
            </div>
          </Spacing>

          <Spacing
            spacing="xl"
            placement="bottom"
            type="margin"
            style={{ display: 'flex', alignItems: 'center', gap: 12 }}
          >
            <div style={{ width: '50%' }}>
              <InputTitle title="Reps per set" />
              <TextInput
                name="reps"
                containerStyle={{ maxWidth: 'auto' }}
                inputStyle={{
                  backgroundColor: 'transparent',
                }}
                type="number"
                value={values.reps}
                onChange={handleChange}
                disabled={disabledField}
                min={1}
                onKeyPress={handleKeyPress}
              />
            </div>
            <div style={{ width: '50%' }}>
              <InputTitle title="Sets" />
              <TextInput
                name="sets"
                containerStyle={{ maxWidth: 'auto' }}
                inputStyle={{
                  backgroundColor: 'transparent',
                }}
                type="number"
                value={values.sets}
                onChange={handleChange}
                disabled={disabledField}
                min={1}
                onKeyPress={handleKeyPress}
              />
            </div>
            <div style={{ width: '50%' }}>
              <InputTitle title="Set duration (s)" />
              <TextInput
                name="duration"
                containerStyle={{ maxWidth: 'auto' }}
                inputStyle={{
                  backgroundColor: 'transparent',
                }}
                type="number"
                value={values.duration}
                onChange={handleChange}
                disabled={disabledField}
                min={1}
                onKeyPress={handleKeyPress}
              />
            </div>
            <div style={{ width: '50%' }}>
              <InputTitle title="Rest time (s)" />
              <CustomInput>
                <TextInput
                  name="restTime"
                  containerStyle={{ maxWidth: 'auto' }}
                  inputStyle={{
                    backgroundColor: 'transparent',
                  }}
                  type="number"
                  value={values.restTime}
                  onChange={handleChange}
                  disabled={disabledField}
                  min={1}
                  onKeyPress={handleKeyPress}
                />
              </CustomInput>
            </div>
          </Spacing>
        </>
      )}

      <Video
        videoUrl={videoUrl.value}
        handleGetWidthAndHeightVideo={handleGetWidthAndHeightVideo}
        handleRemoveVideo={handleRemoveVideo}
        onChangeVideo={onChangeVideo}
      />

      <Spacing spacing="xl" placement="bottom" type="margin">
        <InputTitle title="Exercise thumbnail (optional)" />

        {thumbnailUrl.value && !thumbnailUrl.value.includes('thumbnail-default') ? (
          <div>
            <img
              onLoad={handleGetWidthAndHeightThumbnail}
              src={thumbnailUrl.value}
              alt="thumbnail"
              style={{ maxWidth: 240, maxHeight: 240 }}
            />
            <Typography
              style={{
                whiteSpace: 'nowrap',
                color: '#FF4D4F',
                fontSize: '16px',
                cursor: 'pointer',
              }}
              onClick={handleRemoveThumbnail}
            >
              Remove thumbnail
            </Typography>
          </div>
        ) : (
          <CustomFileUpload>
            <FileUpload
              id={'thumbnail'}
              icon={<UploadIcon />}
              title=" "
              onChangeFiles={onChangeThumbnail}
              accept=".png,.jpeg,.svg,.webp"
              style={{ height: 135, width: 240 }}
            />
          </CustomFileUpload>
        )}
      </Spacing>

      <Spacing spacing="md" placement="bottom" type="margin">
        <InputTitle title="Description (optional)" />
        <Textarea
          name="description"
          value={values.description}
          onChange={handleChange}
          style={{
            resize: 'none',
            padding: '6px 10px',
            backgroundColor: 'transparent',
          }}
          containerStyle={{
            maxWidth: 'auto',
          }}
          disabled={disabledField}
        />
      </Spacing>

      {!disabledField && (
        <Footer
          onCancel={onCancel}
          onSubmit={handleSubmit}
          disabled={exerciseId ? disabledButton : disabled}
          titleSubmit={exerciseId ? 'Save' : 'Add'}
          titleCancel={exerciseId && 'Cancel changes'}
          disabledCancel={exerciseId ? disabledButton : false}
        />
      )}

      <ConfirmModal
        modalKey={MODAL_KEY.DELETE_EXERCISE}
        content={'Deleting will also remove them from all existing lessons.'}
        header={`Delete exercises`}
        onCancel={() => closeModal(MODAL_KEY.DELETE_EXERCISE)}
        onSubmit={handleDeleteExercise}
      />
    </div>
  );
};
